import React, { lazy } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  Link,
} from "react-router-dom";
import { useState } from "react";
import { ToastContainer, notifyError, notifySuccess } from "./utils/toast";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import PrivateRoute from "./components/login/PrivateRoute";
// import { fetchToken, onMessageListener } from "./firebase";
import { Button } from "@windmill/react-ui";
// import CustomAlert from "./components/alerts";

// let sound = new Audio("https://uatimages.wroti.app/notifications.mp3");

const Layout = lazy(() => import("./layout/Layout"));
const Login = lazy(() => import("./pages/Login"));
const SignUp = lazy(() => import("./pages/SignUp"));
const ForgetPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));

const App = () => {
  const [notification, setNotification] = useState({ title: "", body: "" });
  const [isTokenFound, setTokenFound] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  // fetchToken(setTokenFound);
  // onMessageListener()
  //   .then((payload) => {
  //     console.log("MESSAGE RECEIVED", "DDDDDD", payload);
  //     sound.play();
  //     // setNotification({title: payload.notification.title, body: payload.notification.body})
  //     //  setShow(true);
  //     setShowAlert(true);
  //   })
  //   .catch((err) => console.log("failed: ", err));

  // const stopSound = () => {
  //   console.log("Stop sound");

  //   if (sound) sound.pause();
  // };

  return (
    <>
      <ToastContainer />
      <Router>
        <AccessibleNavigationAnnouncer />
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/signup" component={SignUp} />
          <Route path="/forgot-password" component={ForgetPassword} />
          <Route path="/reset-password/:token" component={ResetPassword} />

          <PrivateRoute>
            {" "}
            <Route path="/" component={Layout} />
          </PrivateRoute>
          <Redirect exact from="/" to="/login" />
        </Switch>
        {/* {showAlert && (
          <>
            <CustomAlert
              onOkPress={stopSound}
              message="New order received"
              showAlert={showAlert}
              setShowAlert={setShowAlert}
            />
          </>
        )} */}
      </Router>
    </>
  );
};

export default App;

//An error occurred while retrieving token.  FirebaseError: Messaging: We are unable to register the default service worker. Failed to register a ServiceWorker for scope ('http://localhost:4000/firebase-cloud-messaging-push-scope') with script ('http://localhost:4000/firebase-messaging-sw.js'): The script has an unsupported MIME type ('text/html').
